import {
  type ApiRoleStrategy,
  type LaboratoriesDataRefApi,
  ROLES,
  api,
  laboratoryDataRefApiRoleConf,
  useQuery,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import { datarefToReferentialCode } from "@pharmupp/p3-front-commons/src/dataref/datarefToReferentialCode"
import { formatApiNews } from "../../../commons/NewsComponents/News"
import type { ApiDisplayNews } from "../../model"

export const useAdminNewsPreview = (newsId: string) => {
  const { endpoint, queryKey } = useRoleConf(newsApiConf(newsId))
  const labDataref = useRoleConf(laboratoryDataRefApiRoleConf)

  const { data: post, isLoading: postLoading } = useQuery({
    queryKey,
    queryFn: () => api.get<ApiDisplayNews>(endpoint),
  })

  const shouldFetchDataRef = !!post && !!post?.laboratoryId

  const { data: labs = [], isLoading: labsLoading } = useQuery({
    queryKey: labDataref.queryKey,
    queryFn: () => api.get<LaboratoriesDataRefApi[]>(labDataref.endpoint),
    enabled: shouldFetchDataRef,
  })

  const currentLab = labs?.find((lab) => lab.id === post?.laboratoryId)

  const news = post
    ? {
        ...formatApiNews({
          ...post,
          logo: currentLab?.logo,
        }),
        lab: currentLab,
      }
    : post

  return {
    news,
    loading: postLoading || labsLoading,
    labsReferential: datarefToReferentialCode(labs),
  }
}

const presidentConf = (id: string) => ({
  endpoint: `/api/news/upp/post/${id}`,
  queryKey: ["news", "upp", "post", id],
})

const newsApiConf = (id: string): ApiRoleStrategy => ({
  [ROLES.ADMIN]: {
    endpoint: `/api/news/post/${id}`,
    queryKey: ["news", "post", id],
  },
  [ROLES.UPP_PRESIDENT]: presidentConf(id),
  [ROLES.UPP_REPRESENTATIVE]: presidentConf(id),
})
